import { c as _c } from "react/compiler-runtime";
import { Card, Shimmer } from '@onefootprint/ui';
const CustomStatusLoadingShimmer = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Card.Header title={<Shimmer height="20px" width="140px" />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-3"><Shimmer height="12px" width="12px" className="rounded-full" /><Shimmer height="16px" width="100px" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Card.Root>{t0}<Card.Body><div className="flex flex-col p-2 gap-4">{t1}<div className="flex items-center gap-3"><Shimmer height="12px" width="12px" className="rounded-full" /><Shimmer height="16px" width="80px" /></div></div></Card.Body></Card.Root>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default CustomStatusLoadingShimmer;